import styled, { css } from "styled-components";
import { theme } from "../theme/lexusTheme";

const REACHOUT_SIDEPANEL_HEIGHT = 58;
const NOTIFICATION_WRAPPER_WIDTH = 279;

export const Wrapper = styled.div<{
    marginTop: number;
    isFadingOut?: boolean;
    transition?: boolean;
    reachoutSidepanelWidth?: number;
}>`
    position: fixed;
    top: calc(30vh + ${REACHOUT_SIDEPANEL_HEIGHT}px);
    right: ${({ reachoutSidepanelWidth }) => (reachoutSidepanelWidth ? `${reachoutSidepanelWidth}px` : 0)};
    width: ${NOTIFICATION_WRAPPER_WIDTH}px;
    padding: ${theme.space[3]}px;
    background-color: ${theme.colors.azure};
    border-radius: 3px 0 0 3px;
    transition: right 0.5s ease-out;
    z-index: ${theme.zIndex.fixed};
    animation: fadeInAnimation 0.5s;

    @keyframes fadeInAnimation {
        0% {
            transform: translateX(100%);
        }
        100% {
            transform: translateX(0);
        }
    }

    @keyframes fadeOut {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

    ${({ transition }) =>
        transition &&
        css`
            transition:
                margin-top 0.2s,
                right 0.5s;
        `}

    ${({ isFadingOut }) =>
        isFadingOut &&
        css`
            animation: fadeOut forwards 0.5s ease-out;
            animation-delay: 5s;
        `};

    ${({ marginTop }) =>
        marginTop &&
        css`
            margin-top: ${marginTop}px;
        `};
`;

export const Title = styled.h2`
    margin: 0 0 ${theme.space[1]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.3rem;
    line-height: 2rem;
    color: ${theme.colors.white};
`;

export const Text = styled.p`
    margin: 0;
    font-family: ${theme.fonts.book};
    font-size: 1.3rem;
    line-height: 2rem;
    color: ${theme.colors.white};
`;
